const Account = ()=>{
    return(
        <h1>Account</h1>
    )
}

export default Account